import { printHtmlNodesToText, printHtmlNodesToJsx, generateJsxKey } from '@utils/ast';
import { IframeComponent } from './iframe-component.js';
import { jsx } from 'react/jsx-runtime';
import { getComponentFrameworkDisplayData } from './api/component-framework.get-display-data.js';

const printIframeComponent = (node, context) => {
  return basePrinter(node, context);
};
const printIframeComponentFramework = (node, context) => {
  return basePrinter(node, context);
};
function basePrinter(node, context) {
  return /*#__PURE__*/jsx(IframeComponent, {
    autoActivate: node.options.autoActivate,
    isScrambled: node.pm2.isScrambled,
    desiredDisplayMode: node.options.desiredDisplayMode,
    displayCaption: node.options.displayCaption,
    displayTitle: node.options.displayTitle,
    caption: node.meta.caption,
    indexOrLevel: node.meta.indexOrLevel,
    previewImageSrc: node.meta.previewImage,
    richTextDescription: printHtmlNodesToJsx(node.meta.richTextDescription),
    lightboxDescription: node.meta.lightboxDescription ? printHtmlNodesToText(node.meta.lightboxDescription) : undefined,
    learningObjectId: node.pm2.learningObjectId,
    target: node.options.target,
    getDisplayData: user => node.nodeType === "iframe-component.component-framework" ? getComponentFrameworkDisplayData(node, user) : node.displayData,
    contentType: node.meta.contentType
  }, generateJsxKey(context));
}
const iframeComponentJsxPrinters = {
  "iframe-component": printIframeComponent,
  "iframe-component.component-framework": printIframeComponentFramework
};

export { iframeComponentJsxPrinters, printIframeComponent, printIframeComponentFramework };
//# sourceMappingURL=printer.to-jsx.js.map
